import { CloseIcon, JoonUIColor, Typography } from "@joonapp/web-shared"

import ChildMailbox from "./ChildMailbox"
import useMailboxStore from "./hooks/useMailboxStore"
import SendMailButton from "./SendMailButton"
import SlideUpModal from "../../../../components/slideUpModal/SlideUpModal"
import { useFamilyQuery } from "../../../../networking/queries"
import { FamilyQuerySelect } from "../../../../types"
import { getChildImage } from "../../../../util/util"

const MailboxModal = () => {
  const { isOpenChildMailbox, onCloseChildMailbox, selectedUserId } =
    useMailboxStore()
  const { data: children } = useFamilyQuery(FamilyQuerySelect.CHILDREN)

  const childProfile = children?.find(
    (child) => child.user.id === selectedUserId
  )

  if (!childProfile) return <></>

  const childImage = getChildImage(childProfile.user)

  return (
    <SlideUpModal
      isOpen={isOpenChildMailbox}
      onClose={onCloseChildMailbox}
      size="fit-content"
      backgroundType="overlay"
    >
      <div className="flex flex-col min-h-[90vh]">
        <button
          onClick={onCloseChildMailbox}
          className="absolute top-6 right-4 p-2"
        >
          <CloseIcon color={JoonUIColor.icon.neutral} />
        </button>
        <div className="flex flex-row gap-4 items-center bg-gray-100 p-4 rounded-md">
          <img
            src={childImage}
            className="w-9 min-w-9 h-9 min-h-9 rounded-full"
            alt={childProfile?.user.name}
          />
          <Typography variant="h3">{childProfile?.user.name}</Typography>
        </div>
        <ChildMailbox />
        <div className="absolute bottom-4 right-4">
          <SendMailButton userId={childProfile.user.id} />
        </div>
      </div>
    </SlideUpModal>
  )
}

export default MailboxModal
